export const tryParseJson = <T>(jsonContent: string | null | undefined): T | null => {
    try {
        if (!jsonContent) {
            return null;
        }

        const result = JSON.parse(jsonContent) as T;
        return result;
    } catch {
        return null;
    }
};
